export default __webpack_public_path__ + "static/connections-d00a8823ea222e7c0788abd67e670bab.jpg";